<script setup></script>
<template>
  <section class="content"></section>
</template>
